/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimEmailWithRecipients } from './ClaimEmailWithRecipients';
import {
    ClaimEmailWithRecipientsFromJSON,
    ClaimEmailWithRecipientsFromJSONTyped,
    ClaimEmailWithRecipientsToJSON,
    ClaimEmailWithRecipientsToJSONTyped,
} from './ClaimEmailWithRecipients';

/**
 * Response after sending an email
 * @export
 * @interface SendClaimEmailResponse
 */
export interface SendClaimEmailResponse {
    /**
     * Whether the email was sent successfully
     * @type {boolean}
     * @memberof SendClaimEmailResponse
     */
    success: boolean;
    /**
     * 
     * @type {ClaimEmailWithRecipients}
     * @memberof SendClaimEmailResponse
     */
    email?: ClaimEmailWithRecipients;
    /**
     * Gmail API message ID
     * @type {string}
     * @memberof SendClaimEmailResponse
     */
    gmailMessageId?: string;
    /**
     * Gmail API thread ID
     * @type {string}
     * @memberof SendClaimEmailResponse
     */
    gmailThreadId?: string;
    /**
     * Error message if sending failed
     * @type {string}
     * @memberof SendClaimEmailResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the SendClaimEmailResponse interface.
 */
export function instanceOfSendClaimEmailResponse(value: object): value is SendClaimEmailResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function SendClaimEmailResponseFromJSON(json: any): SendClaimEmailResponse {
    return SendClaimEmailResponseFromJSONTyped(json, false);
}

export function SendClaimEmailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendClaimEmailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'email': json['email'] == null ? undefined : ClaimEmailWithRecipientsFromJSON(json['email']),
        'gmailMessageId': json['gmailMessageId'] == null ? undefined : json['gmailMessageId'],
        'gmailThreadId': json['gmailThreadId'] == null ? undefined : json['gmailThreadId'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function SendClaimEmailResponseToJSON(json: any): SendClaimEmailResponse {
    return SendClaimEmailResponseToJSONTyped(json, false);
}

export function SendClaimEmailResponseToJSONTyped(value?: SendClaimEmailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'email': ClaimEmailWithRecipientsToJSON(value['email']),
        'gmailMessageId': value['gmailMessageId'],
        'gmailThreadId': value['gmailThreadId'],
        'error': value['error'],
    };
}

